<template>
  <div>
   <v-overlay :value="isLoading">
       <v-progress-circular
         indeterminate
         size="74"
       ></v-progress-circular>
     </v-overlay>

   <div>
     <v-row justify="center">
     <v-dialog v-model="dialog" persistent max-width="290">
       <v-card>
         <v-card-title class="headline">Selecione o Trimestre</v-card-title>
          <v-col cols="12" md="12" >
             <v-select
               v-model="trimestre"
               item-value="idTrimestre"
               item-text="descricao"
               :items="trimestres"
                filled
               color="blue-grey lighten-2"
               label="Trimestre"
             ></v-select>
           </v-col>
           <v-card-actions>
           <v-spacer></v-spacer>
           <v-btn color="green darken-1" text @click="dialog=false">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click="CarregaBoletim()">Concordar</v-btn>
         </v-card-actions>
       </v-card>
     </v-dialog>
   </v-row>
   </div>
   <div><v-btn  @click="(backTo!== null)?$router.push(backTo):backTodisciplinList" class="mx-2" fab dark color="primary"><v-icon dark>arrow_back</v-icon></v-btn><iframe  style="width:100%;height:805px" :src="readfile"  title="SoftlineAngola"></iframe></div>

  </div>
 </template>
<script>
import axios from '../../../../../plugins/axios'
const ls = require('local-storage')
export default {
  data: () => ({
    insignia: ls.get('insignia'),
    logotipo: (ls.get('i_id') === 24 ? ls.get('logotipo') : ls.get('insignia')),
    backTo: null,
    dialog: true,
    readfile: '',
    readImage: ls.get('urlReport') + `readfile/`,
    url: ls.get('urlReport'),
    progresso: false,
    listaAlunos: [],
    html: ``,
    trimestre: 0,
    isLoading: false,
    inscricoes: [],
    trimestres: [{ idTrimestre: 1, descricao: '1º Trimestre' }, { idTrimestre: 2, descricao: '2º Trimestre' }, { idTrimestre: 3, descricao: '3º Trimestre' }] // { idTrimestre: 4, descricao: 'Todos' } ]
  }),

  created () {
    this.backTo = ls.get('backTo')
  },

  methods: {

    async CarregaBoletim () {
      this.dialog = false
      this.isLoading = true
      try {
        this.listaAlunos = await axios
          .post('/boletimTurma', { turma: this.$store.state.objturma, trimestre: this.trimestre })
          .then(res => res.data)
        this.comporHtml()
      } catch (error) {
        this.isLoading = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async comporHtml () {
      try {
        let elementold = this.listaAlunos[0]
        let dadosBoletim = ``
        let linha = ``
        let assinatura = (ls.get('i_id') === 24 ? 'O(A) Director(a) de Turma' : 'O Coordenador do Curso')
        let classe = ''
        switch (parseInt(this.$store.state.objturma.idAno_Academico)) {
          case 1:
            classe = '10ª'
            break
          case 2:
            classe = '11ª'
            break
          case 3:
            classe = '12ª'
            break
          case 4:
            classe = '13ª'
            break
          default:
            classe = ''
            break
        }

        // ` + this.url + `readfile/ilhaverdade.jpg
        for (let index = 0; index < this.listaAlunos.length; index++) {
          const element = this.listaAlunos[index]

          if (element.pkInscricao_na_turma !== elementold.pkInscricao_na_turma || this.listaAlunos.length === (index + 1)) {
            dadosBoletim += `       
           <div class="column" style="padding-top:10px">
             <div class="card">
              <center> <img src= ` + this.logotipo + ` alt="Snow" style="width:50%; max-width:50px;" /> </center><br>
                         <table  class="removerborder" cellpadding="0" cellspacing="0" width="100%">
                          <tr class="removerborder"> <th style="font-size: 10px;text-align:center;" class="removerborder">REPÚBLICA DE ANGOLA</th></tr>
                          <tr class="removerborder"><th style="font-size: 10px;text-align:center;" class="removerborder">MINISTÉRIO DA EDUCAÇÃO</th></tr>
                           <tr class="removerborder"><th style="font-size: 10px;text-align:center;" class="removerborder">` + ls.get('instituicaodescricao').toUpperCase() + `</th></tr>
                           <tr class="removerborder"><th style="font-size: 10px;text-align:center;" class="removerborder"><br>BOLETIM DE NOTAS</th></tr>
                           </table> 
                         <br>
                           <table width="100%" cellpadding="0" cellspacing="0" class="removerborder">                                         
                                          <tr class="removerborder">
                                              <td colspan="5" class="removerborder">
                                                  <table class="removerborder" width="100%">
                                                      <tr style="font-size: 8px;" class="removerborder">
                                                          <td class="removerborder">
                                                              <strong> Nome: ` + element.nome.toUpperCase() + `</strong> <br>
                                                               Nº de Processo: ` + element.matricula + `<br>
                                                               Ano lectivo: ` + this.$store.state.objturma.anoLectivo + `<br>
                                                          Curso: ` + this.$store.state.objturma.curso + `                                 
                                                          </td>
                                                          <td style="text-align: justify;" class="removerborder">
                                                           Trimestre:  ` + this.trimestre + `º<br>
                                                           Turma: ` + this.$store.state.objturma.turmadescricao + `  <br>
                                                          Periodo: ` + this.$store.state.objturma.periodo + `<br>
                                                          Classe: ` + classe + `
                                                          </td>
                                                      </tr>
                                                  </table>
                                                 </td>
                                           </tr>
                                           <tr style="font-size: 10px;">
                                             <th  style="text-align:center;background: #eee;" rowspan="2">
                                            Disciplinas
                                             </th>
                                             
                                           <tr style="font-size: 10px ;" rowspan="2">
                                             <th  style="text-align:center;background: #eee;">
                                            Mac
                                             </th>
                                             <th  style="text-align:center;background: #eee;" >
                                                P1
                                             </th>
                                              <th  style="text-align:center;background: #eee;">
                                                P2
                                             </th>
                                              <th  style="text-align:center;background: #eee;">
                                               MT
                                             </th>
                                         </tr> 
                                         ` + linha + `
                                                  </table>
                         
         <div>
         <p style="text-align:center;font-size: 8px ;">Para os devidos efeitos, passou-se o presente Boletim de Notas que vai por mim assinado.</p>
           <p style="text-align:center;font-size: 8px ;">Luanda, ` + this.dia() + ` de ` + this.monthName() + `</p> 
         <table width="100%" class="removerborder">
           <tr class="removerborder">
               <td style="text-align:center;font-size: 8px;" class="removerborder">` + assinatura + `</td>
               <td style="text-align:center;font-size: 8px;" class="removerborder">O SubDirector(a) Pedagógico(a)</td>
           </tr>
           <tr class="removerborder">
               <td style="text-align:center;font-size: 8px ;" class="removerborder">_____________________________</td>
               <td style="text-align:center;font-size: 8px ;" class="removerborder">_____________________________</td>
           </tr>
         </table>
             <p class="item" style="text-align:center;font-size: 8px;">Saúde e sabedoria!</p>
         </div>
           </div>
         </div>
 `
            linha = ``
          }
          linha += `<tr style="font-size: 9px;" class="item">
                     <td >
                         ` + element.disciplina + `
                     </td>
                     <td style="text-align:center;">
                         ` + this.isNull(element.t_mac) + `
                     </td>
                     <td  style="text-align:center;">
                         ` + this.isNull(element.t_nota1) + `
                     </td>
                     <td  style="text-align:center;">
                          ` + this.isNull(element.t_nota2) + `
                     </td>
                     <td  style="text-align:center;">
                          ` + this.isNull(element.t_md) + `
                     </td>
                 </tr>`
          elementold = this.listaAlunos[index]
        }
        this.html = `<html>
 <head>
 <meta name="viewport" content="width=device-width, initial-scale=1">
 <style>
 
 table, th, td {
   border: 1px solid #ddd;
   font-family: Arial, Helvetica, sans-serif;
 }
 .removerborder {
   border: 0px solid black;
   font-family: Arial, Helvetica, sans-serif;
 }
 * {
   box-sizing: border-box;
 }
 
 body {
   font-family: Arial, Helvetica, sans-serif;
 }
 
 /* Float four columns side by side */
 .column {
   float: left;
   width: 50%;
   padding: 0 10px;
   font-family: Arial, Helvetica, sans-serif;
 }
 
 /* Remove extra left and right margins, due to padding */
 .row {margin: 0 -5px;}
 
 /* Clear floats after the columns */
 .row:after {
   content: "";
   display: table;
   clear: both;
 }
 
 /* Responsive columns */
 @media screen and (max-width: 600px) {
   .column {
     width: 100%;
     display: block;
     margin-bottom: 20px;
   }
 }
 
 /* Style the counter cards */
 .card {
   box-shadow: 0 4px 8px 0 #808080;
   padding: 16px;
   text-align: center;
   background-color: #ffffff;
   border-radius: 5px;
   height: 525px;
   font-family: Arial, Helvetica, sans-serif;
 }
 </style>
 </head>
 <body>
 <div class="row"> ` + dadosBoletim + `</div>`
        let option = { 'format': 'A4',
          'border': {
            'right': '25cm',
            'left': '25cm'
          },
          'header': {
            'height': '1mm' },
          'footer': {
            'height': '1mm'
          } }
        this.boletimgerarPdf(option)
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
        this.isLoading = false
      }
    },

    isNull (nota) {
      if (nota) { return nota } else return ''
    },
    async boletimgerarPdf (option) {
      try {
        let result = await axios({
          method: 'post',
          url: this.url + 'writefile',
          data: {
            html: this.html + '</body></html>',
            file_name: ls.get('idPessoa'),
            option: option
          }
        }).then((res) => res.data)
        this.readfile = this.url + 'readfile/' + ls.get('idPessoa') + '.pdf'
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
        this.isLoading = false
      } finally {
        this.isLoading = false
      }
    },
    monthName () {
      let d = new Date()
      let month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Março'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return month[d.getMonth()] + ' ' + 'de' + ' ' + (d.getFullYear()).toString()
    },
    dia () {
      var day = new Date()
      day = day.getDate()
      day = day.toString()
      return day
    },
    backToTurmaList () {
      this.disciplinas = []
    },
    backTodisciplinList () {
      this.$router.push('turmacrud24')
    }
  }
}
</script>
 <style>
  .tabela {
     border: 1px solid rgba(0,0,0,.12);
     font-size: 12px!important;

 }
  .tabelath {
     border: 1px solid rgba(0,0,0,.12);
     font-size: 12px !important;
 }
 .tdsize {
     width: 3px!important;
 }

 </style>
